import AxiosFactory from '@/entities/security/AxiosFactory'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { GET_MASS_PAYMENT_INVOICE_URL, CREATE_MASS_PAYMENT_INVOICE_URL } from '@/modules/massPayment/endpoints'
import { CreateMassPaymentPayload } from './types/api/CreateMassPaymentPayload'

export default class MassPaymentApi {
  async loadMassPaymentInvoice() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(GET_MASS_PAYMENT_INVOICE_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async createMassPaymentInvoice(ids: CreateMassPaymentPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(CREATE_MASS_PAYMENT_INVOICE_URL, ids)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
